import {useMutation, useQuery} from '@tanstack/react-query';
import {useForm} from 'react-hook-form';
import {ReportApi, TerminalApi} from '../../api';
import {useProfile} from '../../hooks';
import {formatDateForInput} from '../../utils';
import type {TerminalPoolReportParams} from "../../api/Report.api";
import {LoadingButton} from '../atoms';

export const TerminalPollReportCard = () => {
    const profile = useProfile();

    const {data: terminalPoolList = []} = useQuery({
        queryKey: [TerminalApi.KEY, 'getTerminalPool'],
        queryFn: TerminalApi.getTerminalPool,
    });
    const {handleSubmit, register, watch} = useForm<TerminalPoolReportParams>();
    const periodStart = watch('periodStart');
    const periodEnd = watch('periodEnd');

    const {mutate, isPending} = useMutation({
        mutationFn: ReportApi.poolBalance,
    });

    const onSubmit = (data: TerminalPoolReportParams) => {
        mutate(data);
    }

    if (!profile || !profile.permissions.includes('report.read.pool.balance')) {
        return null;
    }

    return (
        <li className="p-4 rounded-2xl shadow-1 bg-white flex flex-col min-w-[320px]">
            <h2 className="mb-5 text-lg font-bold text-center">Terminal Pool Balance</h2>
            <form className="grid gap-5 h-full" onSubmit={handleSubmit(onSubmit)}>
                <div className="grid grid-cols-3 gap-4">
                    <label>
                        <span className="mb-1 block text-brand-2 text-sm pl-4">Date From</span>
                        <input
                            {...register('periodStart', {
                                required: true,
                                valueAsDate: true,
                            })}
                            className="input w-full"
                            max={formatDateForInput(new Date(periodEnd))}
                            type="date"
                        />
                    </label>
                    <label>
                        <span className="mb-1 block text-brand-2 text-sm pl-4">Date To</span>
                        <input
                            {...register('periodEnd', {
                                required: true,
                                valueAsDate: true,
                            })}
                            className="input w-full"
                            min={formatDateForInput(new Date(periodStart))}
                            type="date"
                        />
                    </label>

                    <label>
                        <span className="mb-1 block text-brand-2 text-sm pl-4">Terminal pool</span>
                        <select
                            {...register('terminalPoolId', {  required: true, valueAsNumber: false })}
                            className="input appearance-none w-full"
                        >
                            <option value="">Not selected</option>
                            {terminalPoolList.map((pool) => (
                                <option key={pool.id} value={pool.id}>
                                    {pool.name}
                                </option>
                            ))}
                        </select>
                    </label>
                </div>

                <LoadingButton 
                  isLoading={isPending}
                  type="submit"
                >
                  Get report
                </LoadingButton>
            </form>
        </li>
    );
};
